module.exports = __webpack_public_path__ + "img/9788996100119.15d0c33b.jpg";